import React, { useEffect, useState } from "react";
import axios from "axios";
import cookie from "js-cookie";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import userPlaceholder from "../../assets/images/placeholder.jpg";
import Loader from "../../components/shared/Loader";
// import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
// import { CKEditor } from "@ckeditor/ckeditor5-react";
// import { CKEditor } from "ckeditor4-react";
import { updateMeta } from "../../store/actions/metaAction";

import JoditEditor from "components/shared/JoditEditor";

const BlogCreate = () => {
	const auth = useSelector(state => state.auth.user);
	const history = useHistory();
	const [title, setTitle] = useState("");
	const [description, setDescription] = useState("");
	const [picture, setPicture] = useState(userPlaceholder);
	const [loading, setLoading] = useState(true);
	const [categories, setCategories] = useState([]);
	const [selectedCategory, setSelectedCategory] = useState(0);
	const [pageTitle, setPageTitle] = useState("");
	const [pageUrl, setPageUrl] = useState("");
	const [pageDescrition, setPageDescrition] = useState("");
	const [pageKeyWords, setPageKeyWords] = useState("");
	const dispatch = useDispatch();

	// let editor = null;

	useEffect(() => {
		onStart();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const onStart = () => {
		dispatch(
			updateMeta({
				title: "اضافة مقال جديد",
				breadcrumb: "المدونة",
				button: {
					show: false,
					text: null,
					link: null,
				},
			})
		);
		axios
			.get(`${process.env.REACT_APP_API_URL}/blog_categories`, {
				headers: {
					Authorization: `Bearer ${cookie.get("token")}`,
					Accept: "application/json",
				},
			})
			.then(function (response) {
				setCategories(response.data.data);
				setLoading(false);
			})
			.catch(function (error) {
				toast.error("خطأ، برجاء المحاولة لاحقا!");
			});
	};

	const handlePicture = () => {
		const fileInput = document.querySelector("#picture");
		setPicture(URL.createObjectURL(fileInput.files[0]));
	};

	const handleSubmit = e => {
		e.preventDefault();
		if (selectedCategory === 0) {
			toast.error("برجاء اختيار التصنيف أولا!");
			return;
		}
		const picture = document.querySelector("#picture");
		if (picture.files[0]) {
			setLoading(true);
			const data = new FormData();
			data.append("file", picture.files[0]);
			axios
				.post(`${process.env.REACT_APP_API_URL}/upload`, data, {
					headers: {
						Authorization: `Bearer ${cookie.get("token")}`,
						Accept: "application/json",
						"Content-Type": "multipart/form-data",
					},
				})
				.then(response => {
					const titleArray = {
						ar: title,
						en: "ttt",
					};
					const descriptionArray = {
						ar: description,
						en: "ttt",
					};
					axios
						.post(
							`${process.env.REACT_APP_API_URL}/blogs`,
							{
								title: titleArray,
								description: descriptionArray,
								admin_id: auth.data.id,
								category_id: selectedCategory,
								image: response.data.data.name,
								page_title: pageTitle,
								page_description: pageDescrition,
								page_keywords: pageKeyWords,
								page_url_title: pageUrl,
							},
							{
								headers: {
									Authorization: `Bearer ${cookie.get("token")}`,
									Accept: "application/json",
								},
							}
						)
						.then(function (response) {
							history.push("/blog/index");
							toast.success("تم اضافة المقالة بنجاح!");
							setLoading(false);
						})
						.catch(function (error) {
							toast.error("خطأ، برجاء المحاولة مره اخرى!");
							setLoading(false);
						});
				})
				.catch(error => {
					toast.error("خطأ في رفع الصورة، برجاء المحاولة مرة أخرى!");
					setLoading(false);
				});
		} else {
			toast.error("برجاء اختيار الصورة أولا!");
		}
	};

	// const useDarkMode = window.matchMedia("(prefers-color-scheme: dark)").matches;

	return (
		<section>
			{loading && <Loader />}
			<form onSubmit={handleSubmit}>
				<div className="row">
					<div className="col-md-9">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="category">التصنيف</label>
									<select
										id="category"
										onChange={e => setSelectedCategory(e.target.value)}
									>
										<option value="0">اختر التصنيف</option>
										{categories.map(category => (
											<option value={category.id} key={category.id}>
												{category.name}
											</option>
										))}
									</select>
								</div>
								<div className="form-item">
									<label htmlFor="title">العنوان</label>
									<input
										type="text"
										id="title"
										required
										onChange={e => setTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="description">النص</label>

									{/* <Editor
										onChange={({ level }) => {
											setDescription(level.content);
										}}
										apiKey="qxbhpez69tx8w5eo9pwc1ark6iqt3cwvrygww12thb0gta0f"
										init={{
											plugins:
												"print preview paste importcss searchreplace autolink autosave save directionality code visualblocks visualchars fullscreen image link media template codesample table charmap hr pagebreak nonbreaking anchor toc insertdatetime advlist lists wordcount imagetools textpattern noneditable help charmap quickbars emoticons",
											menubar: "file edit view insert format tools table help",
											toolbar:
												"customInsertButton | undo redo | bold italic underline strikethrough | fontselect fontsizeselect formatselect | alignleft aligncenter alignright alignjustify | outdent indent |  numlist bullist | forecolor backcolor removeformat | charmap emoticons | fullscreen  preview print | insertfile image media link table | ltr rtl | language",
											toolbar_sticky: true,
											autosave_ask_before_unload: true,
											autosave_interval: "30s",
											autosave_prefix: "{path}{query}-{id}-",
											autosave_restore_when_empty: false,
											autosave_retention: "2m",
											mobile: {
												menubar: true,
											},
											// directionality: "rtl",
											// language: "ar",
											height: 400,
											image_caption: true,
											quickbars_selection_toolbar:
												"bold italic | quicklink h2 h3 blockquote quickimage quicktable",
											noneditable_noneditable_class: "mceNonEditable",
											toolbar_mode: "wrap",
											contextmenu: "link image imagetools table",
											content_style:
												"body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
											setup: function (editor) {
												editor.ui.registry.addButton("customInsertButton", {
													text: "custom Button",
													onAction: function (_) {
														editor.insertContent(
															`&nbsp;<a href="" class="btn" style="    background: linear-gradient(
																148deg,#1d5cd1,#0ba1d8 84%);
															color: #fff;
															padding: 10px 20px;
															border-radius: 50px;
															display: inline-block;
															cursor: pointer;
															text-decoration: none;">my button!</a>&nbsp;`
														);
													},
												});
											},
										}}
									/> */}
									<JoditEditor
										value={description}
										placeholder="اكتب هنا..."
										onChange={newContent => setDescription(newContent)}
									/>
								</div>
							</div>
						</div>
						<div className="card mt-5">
							<div className="card-header">تفاصيل محركات البحث</div>
							<div className="card-body">
								<div className="form-item">
									<label htmlFor="pageTitle">عنوان الصفحة</label>
									<input
										type="text"
										id="pageTitle"
										required
										onChange={e => setPageTitle(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageUrl">رابط الصفحة</label>
									<input
										type="text"
										id="pageUrl"
										required
										onChange={e => setPageUrl(e.target.value)}
									/>
								</div>
								<div className="form-item">
									<label htmlFor="pageDescription">وصف الصفحة</label>
									<textarea
										id="pageDescription"
										rows="2"
										onChange={e => setPageDescrition(e.target.value)}
										required
									></textarea>
								</div>
								<div className="form-item">
									<label htmlFor="pageKeyWords">الكلمات المفتاحية</label>
									<textarea
										id="pageKeyWords"
										rows="2"
										onChange={e => setPageKeyWords(e.target.value)}
										required
									></textarea>
								</div>
							</div>
						</div>
					</div>
					<div className="col-md-3">
						<div className="card">
							<div className="card-body">
								<div className="form-item">
									<input type="file" onChange={handlePicture} id="picture" />
									<img src={picture} alt="avatar" className="imagePreview" />
								</div>
							</div>
						</div>
						<div className="form-item mt-3">
							<button className="bt bt-success btn-block">ارسال</button>
						</div>
					</div>
				</div>
			</form>
		</section>
	);
};

export default BlogCreate;
